import { render } from "./PatientsDatatableTDTreatmentMessage.vue?vue&type=template&id=1f81b626"
import script from "./PatientsDatatableTDTreatmentMessage.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDTreatmentMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__